// extracted by mini-css-extract-plugin
module.exports = {"SearchPage":"search_SearchPage__DjLxc","Search":"search_Search__1paOI","SearchCardGrid":"search_SearchCardGrid__16NrJ"};